module.exports = __webpack_public_path__ + "ddbbfd026af9419ca44f8d0c35e7f083.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/Foto_Manja_Herrmann-0187_klein.jpg
// module id = 458
// module chunks = 0